<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar" /> 组织机构
        </el-breadcrumb-item>
        <el-breadcrumb-item>机构树</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="8" class="fenge">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row type="flex" justify="end">
                <el-col :span="8">
                  <h4>渠道机构树</h4>
                </el-col>
                <el-col :span="18">
                  <div style="float:right"></div>
                </el-col>
              </el-row>
            </div>
            <el-tree
              :data="departtree"
              :props="eltreeProps"
              default-expand-all
              :expand-on-click-node="false"
              @node-click="nodeclick"
            >
              <span slot-scope="{node,data}" class="custom-tree-node">
                <span>
                  <span>{{ node.label+" " }}{{ data.depart_code }}</span>
                </span>
                <transition name="el-zoom-in-center"></transition>
              </span>
            </el-tree>
          </el-card>
        </el-col>
        <!--点击添加-->
        <!-- 扩展表格begin -->
        <el-col :span="16">
          <el-tabs type="border-card">
            <el-tab-pane :label="tablename+'列表'">
              <el-table
                v-loading="listLoading"
                :data="tableData"
                border
                element-loading-text="拼命加载中"
                style="width:100%"
              >
                <el-table-column prop="openid" label="openid" min-width="200" show-overflow-tooltip />
                <el-table-column prop="name" :label="tablename +'名称'" min-width="100" show-overflow-tooltip />
                <el-table-column prop="phone" label="手机号" min-width="100" show-overflow-tooltip />
                <el-table-column
                  prop="createTime"
                  label="注册时间"
                  min-width="160"
                  show-overflow-tooltip
                />
                <el-table-column prop="provinceName" label="省" />
                <el-table-column prop="cityName" label="市" />
                <el-table-column prop="areaName" label="区" />
                <el-table-column prop="address" label="详细地址" show-overflow-tooltip />
              </el-table>
              <el-pagination
                background
                :current-page.sync="currentPage"
                layout="total,prev, pager, next,jumper"
                :total="total_count"
                @current-change="currentchange"
              />
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <!-- 扩展表格end -->
      </el-row>
      <!--点击添加-->
      <el-divider />
    </div>
  </div>
</template>
<script>
import { getchildren, vipsearch } from "@/api/market/channel";
import { construct, destruct } from "@aximario/json-tree";
import { callbackify } from "util";
export default {
  data() {
    return {
      // 页面基础数据
      listLoading: true,
      filterText: "",
      tabletitle: "经销商列表",
      data: [],
      tableData: [],
      tablename:'经销商名称',
      // 分页数据
      total_count: 1,
      currentPage: 1,
      // 列表转分级树数据
      eltreeProps: {
        children: "children",
        label: "name",
        value: "userUuid",
        id: "userUuid",
        checkStrictly: true
      },
      nodeid: "",
      nodename: "",
      editVisible: false,
      // 部门下拉树
      nodevalue: "",
      result: [],
      departtree: null // 掉接口返回部门树
    };
  },
  watch: {
    // 分级树过滤
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  // 钩子函数
  mounted() {
    // 请求经销商人员列表数据
          vipsearch({
        userType: 9,
        page: 1,
        rows: 10,
        state: 1
      }).then(response => {
        this.tableData = response.data.rows;
        this.total_count = response.data.total;
        this.packdate(this.tableData);
        this.listLoading = false;
      });
    this.getdeparttree(9);
  },
  methods: {
    // 分级树单击节点事件
    nodeclick(value) {
      const userUuid = value.userUuid;
      this.Tabledata(userUuid);
    },
    // 请求人员表格数据
    Tabledata(obj) {
      vipsearch({
        // userType: 9,
        parentUuid: obj,
        page: 1,
        rows: 10,
        state: 1
      }).then(response => {
        this.tableData = response.data.rows;
        this.total_count = response.data.total;
        this.packdate(this.tableData);
        this.listLoading = false;
      });
    },
        packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        switch (obj[i].userType) {
            case 3:this.tablename = '终端'        
            break;
            case 5:this.tablename = '分销商'        
            break;
            case 9:this.tablename = '经销商'        
            break;
          default:
            break;
        }
      }
    },
    // //请求部门树结构
    getdeparttree(obj) {
      getchildren({ userType: obj }).then(response => {
        this.departtree = response.data;
      });
    },
    // 分页跳转事件
    currentchange(value) {
      this.listLoading = true;
      const obj = {
        pageIndex: this.currentPage
      };
      this.Tabledata(obj);
    },
    // 跳转到人员列表
    tiaozhuan() {
      this.$router.push({
        path: "/stafflist"
      });
    }
  }
};
</script>
<style scoped>
.fenge {
  position: relative;
  height: 100%;
  border-right: 2px #dcdfe6 solid;
  padding: 0 3%;
  left: 2px;
}
.fenge1 {
  position: relative;
  height: 100%;
  border-left: 2px #dcdfe6 solid;
  padding: 0 3%;
  left: 0px;
}
</style>
<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
